import postalIcon from '../../../assets/postalIcon.png'

interface InputFileDetailProps {
    id: number
    name: string
    valueKey: 'postal_code_list'
    criteria_quantity: number
}

export const InputFileDetail = ({
    name,
    valueKey,
    criteria_quantity,
}: InputFileDetailProps) => {
    const fileDescriptions = {
        postal_code_list: `Archivo con lista de ${criteria_quantity} códigos postales`,
    }

    return (
        <div className="flex items-center">
            <img src={postalIcon} alt={`${name} icon`} />
            <h3 className="text-[#141A1F] text-[14px] font-normal ml-2">
                {name}:{' '}
                <span className="ml-2 bg-[#F1F5F9] text-[#3E5060] rounded px-2 py-1 text-sm">
                    {fileDescriptions[valueKey]}
                </span>
            </h3>
        </div>
    )
}
